<template>

    <div class="large doc-card" @contextmenu="contextmenu($event)" @dblclick="openPage()">
      <div class="doc-status">
        <el-row>
          <el-col :span="4" >
            <div class="doc-author">{{ docData.newest_ver }}</div>
          </el-col>
          <el-col :span="16" >
            <div class="doc-author">{{ docData['name@status'] }}</div>
          </el-col>
          <el-col :span="4">
            <div class="doc-menu">
              <el-dropdown trigger="click">
                <el-icon>
                  <ElIconArrowDownBold/>
                </el-icon>
                <template #dropdown>
                  <el-dropdown-menu style="width: 100px">
                    <el-dropdown-item @click="openPage()">查看</el-dropdown-item>
                    <el-dropdown-item @click="downloadFile()">文件下载</el-dropdown-item>
                    <el-dropdown-item :disabled="docData.status !== 'doc_status_edit'" @click="reviewDoc(element)">提交审核</el-dropdown-item>
                    <el-dropdown-item :disabled="docData.status === 'doc_status_edit' || docData.status === 'doc_status_review'" @click="openUpdateFile()">升版</el-dropdown-item>
                    <el-dropdown-item @click="deleteDoc()">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="icon" :class="getClass()"></div>
      <div class="doc-name">
        {{ docData.name }}
      </div>
      <div class="doc-time">
        {{ docData.update_time }}
      </div>

    </div>
</template>

<script>

export default {
  name: "DocCard",
  props: {
    docData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {

    }
  },
  methods: {
    async reviewDoc() {
      await this.$http('docService.reviewDoc', this.docData);
      this.$message.success('提交审核成功')
      this.searchDoc();
    },
    deleteDoc() {
      this.$confirm('你确定要删除【' + this.docData.name + '】吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.submitDel(this.docData);
      });
    },
    async submitDel() {
      await this.$http('docService.deleteDoc', this.docData);
      this.$message.success('删除成功')
      this.searchDoc();
    },
    openUpdateFile() {
      let windowObj = {}
      windowObj.icon = "system/view";
      windowObj.component = "frame/FrameForm";
      windowObj.componentParam = "dc_doc_update";
      windowObj.name = "上传新版文档";
      windowObj.parentData = this.docData;
      windowObj.height = 600 || this.$store.getters['core/getGlobalWindowHeight']
      windowObj.width = 800 || this.$store.getters['core/getGlobalWindowWidth']

      this.$store.dispatch('core/openWindow', windowObj)
    },
    downloadFile(appendix) {
      let url = appendix?.sys_file?.url;
      if (!url) {
        return
      }
      let name = appendix.name

      const a = document.createElement('a')

      if (!url.startsWith('http')) {
        url = window.location.protocol + "//" + window.location.host + (url.startsWith('/') ? '' : '/') + url;
      }
      // 这里是将url转成blob地址，
      fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
        a.href = URL.createObjectURL(blob)
        a.download = name || '' // 下载文件的名字
        document.body.appendChild(a)
        a.click()

        //在资源下载完成后 清除 占用的缓存资源
        window.URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      })
    },
    openPage() {
      let windowObj = {}
      windowObj.icon = "system/view";
      windowObj.component = "oa/FileViewerWithVersions";
      windowObj.name = "文档查看";
      windowObj.parentData = this.docData;
      windowObj.height = 600 || this.$store.getters['core/getGlobalWindowHeight']
      windowObj.width = 1100 || this.$store.getters['core/getGlobalWindowWidth']
      windowObj.no_min = true
      windowObj.max = true

      this.$store.dispatch('core/openWindow', windowObj)
    },
    getClass() {
      var suffix = this.docData.suffix.toLowerCase()
      const types = {
        '.pdf': 'pdf',
        '.xlsx': 'excel',
        '.xls': 'excel',
        '.docx': 'word',
        '.doc': 'word',
        '.pptx': 'ppt',
        '.ppt': 'ppt',
        '.jpg': 'png',
        '.png': 'png',
        '.jpeg': 'png',
        '.dwg': 'dwg',
        '.dxf': 'dxf',
        '.txt': 'txt',
        '.mp4': 'video',
        '.mp3': 'audio',
        '.html': 'html',
        '.htm': 'html',
        '.zip': 'zip',
        '.rar': 'rar',
        '.step': 'm3d_step',
        '.stp': 'm3d_stp',
        '.stl': 'm3d_stl',
        '.igs': 'm3d_igs',
        '.glb': 'm3d_glb',
        '.obj': 'm3d_obj',
        '.bin': 'm3d_bin',
        '.ply': 'm3d_ply',
        '.ifc': 'm3d_ifc',
        '.3dm': 'm3d_3dm',
        '.dae': 'm3d_dae',
        '.fbx': 'm3d_fbx',
        '.sldprt': 'sw_part',
        '.sldasm': 'sw_assembly',
        '.slddrw': 'sw_2d'
      }
      return types[suffix] || 'file'
    },
    contextmenu(e) {
      let menuItems = [
        {label: '查看', icon: 'el-icon-search', click: this.openPage},
        {label: '文件下载', icon: 'el-icon-download', click: this.downloadFile},
        {label: '提交审核', icon: 'el-icon-check', disabled: this.docData.status !== 'doc_status_edit', click: this.reviewDoc},
        {label: '升版', icon: 'el-icon-top', disabled: this.docData.status === 'doc_status_edit' || this.docData.status === 'doc_status_review', click: this.openUpdateFile},
        {label: '删除', icon: 'el-icon-delete', divided: true, click: this.deleteDoc}
      ]

      this.$store.dispatch('core/openContextMenu', {
        element: element,
        event: e,
        menuItems: menuItems
      })

    }
  },
  created() {

  }
}
</script>


<style lang="less" scoped>
@import '@/global.less';

.myContainer {
  padding: 5px;
}

.folderButton {
  display: inline-flex;
}

.card-header {
  display: inline-flex;
  height: 36px;
}

.department-name {
  font-size: @fontSizeX;
}


.activeButton {
  background-color: #409EFF;
  color: #FFFFFF
}

.scroller::-webkit-scrollbar {
  width: 3px;
}

.scroller::-webkit-scrollbar-track {
  background-color: transparent;
}

.scroller::-webkit-scrollbar-thumb {
  background-color: #C1C1C1;
}

.doc-box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  min-height: 600px;
}

.doc-card {
  width: 150px;
  height: 210px;
  margin: 10px;
  border: 1px solid gainsboro;
  border-radius: 10px;
}

.doc-card:hover {
  background-color: #E5F3FF;
}

.file-count {
  color: #409EFF;
  font-size: large;
  margin-left: 5px;
}

.pdf {
  background-image: url("../../../../public/icon/filetype/pdf.png");
}

.excel {
  background-image: url("../../../../public/icon/filetype/excel.png");
}

.word {
  background-image: url("../../../../public/icon/filetype/word.png");
}

.ppt {
  background-image: url("../../../../public/icon/filetype/ppt.png");
}

.png {
  background-image: url("../../../../public/icon/filetype/jpg.png");
}

.dwg {
  background-image: url("../../../../public/icon/filetype/dwg.png");
}

.dxf {
  background-image: url("../../../../public/icon/filetype/dxf.png");
}

.video {
  background-image: url("../../../../public/icon/filetype/video.png");
}

.audio {
  background-image: url("../../../../public/icon/filetype/audio.png");
}

.html {
  background-image: url("../../../../public/icon/filetype/html.png");
}

.txt {
  background-image: url("../../../../public/icon/filetype/txt.png");
}

.zip {
  background-image: url("../../../../public/icon/filetype/zip.png");
}

.rar {
  background-image: url("../../../../public/icon/filetype/rar.png");
}

.m3d {
  background-image: url("../../../../public/icon/filetype/3d.png");
}

.m3d_step {
  background-image: url("../../../../public/icon/filetype/3d_step.png");
}

.m3d_stl {
  background-image: url("../../../../public/icon/filetype/3d_stl.png");
}

.m3d_igs {
  background-image: url("../../../../public/icon/filetype/3d_igs.png");
}

.m3d_stp {
  background-image: url("../../../../public/icon/filetype/3d_stp.png");
}

.m3d_glb {
  background-image: url("../../../../public/icon/filetype/3d_glb.png");
}

.m3d_obj {
  background-image: url("../../../../public/icon/filetype/3d_obj.png");
}

.m3d_bin {
  background-image: url("../../../../public/icon/filetype/3d_bin.png");
}

.m3d_ply {
  background-image: url("../../../../public/icon/filetype/3d_ply.png");
}

.m3d_ifc {
  background-image: url("../../../../public/icon/filetype/3d_ifc.png");
}

.m3d_3dm {
  background-image: url("../../../../public/icon/filetype/3d_3dm.png");
}

.m3d_dae {
  background-image: url("../../../../public/icon/filetype/3d_dae.png");
}

.m3d_fbx {
  background-image: url("../../../../public/icon/filetype/3d_fbx.png");
}

.sw_part {
  background-image: url("../../../../public/icon/filetype/sw_part.png");
}

.sw_assembly {
  background-image: url("../../../../public/icon/filetype/sw_assembly.png");
}

.sw_2d {
  background-image: url("../../../../public/icon/filetype/sw_2d.png");
}

.file {
  background-image: url("../../../../public/icon/filetype/file.png");
}

.icon {
  width: 100px;
  height: 100px;
  background-size: 100px 100px;
  margin-left: 25px;
}

.doc-name {
  font-size: 16px;
  width: 100%;
  height: 33px;
  margin-top: 10px;
  margin-bottom: 10px;
  //word-wrap: normal;
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  line-height: 16px;
  padding-left: 10px;
  text-align: center;
}

.doc-version {
  margin-left: 10px;
  font-size: 20px;
  width: 100%;
  height: 25px;
  line-height: 25px;
  text-align: center;
}

.doc-author {
  font-size: 16px;
  width: 100%;
  height: 25px;
  line-height: 25px;
  text-align: center;
}

.doc-time {
  font-size: 14px;
  width: 100%;
  height: 20px;
  line-height: 20px;
  text-align: center;
}

.doc-status {
  font-size: 12px;
  width: 100%;
}

.doc-menu {
  font-size: 14px;
  margin: 5px 0 0 5px;
}

.departmentBody {
  border: #ececec solid 1px;
  font-weight: normal;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
  padding: 0 1px 2px;
}

.departmentLeft {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  box-sizing: content-box;
}

.departmentRight {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: auto;
  width: 100%;
  min-width: 550px;
}

.LeftBody {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  padding-top: 10px;
  overflow-y: auto;
}

.flexRow {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.userRights {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 5px 5px 0 5px;
}

.departmentUserList {
  padding: 0 20px 10px;
  display: flex;
  flex-direction: column;
}

.departmentTitle {
  height: 45px !important;
  line-height: 40px;
  font-size: @fontSizeSS;
}

.departmentName {
  white-space: nowrap;
  min-width: 120px;
  margin-right: 30px;
  padding-right: 20px;
  font-size: @fontSizeS;
}

.titleFlex {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.departmentEdit {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin: 10px 0;
}

.departmentTable {
  border: none;
  width: 100%;
}

.flexRow > .el-menu-item {
  height: 50px;
  line-height: 50px;
}

.buttonGroup {
  margin-left: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.addButton {
  margin-left: 5px !important;
  padding: 9px;
}

.addDepartment {
  width: 140px;
  margin-right: 5px;
}

.LeftBody ::v-deep(.el-tree-node__expand-icon) {
  width: 15px;
}

.buttonGroup ::v-deep(.el-icon-key) {
  transform: rotate(180deg);
}

.editButton {
  color: lightgrey;
  min-height: 30px;
  padding: 0;
}

.editButton:hover {
  color: #00afff;
}

</style>
